import { makeStyles } from 'tss-react/mui';

export default makeStyles()((theme) => ({
  table: {
    width: '50%',
    [theme.breakpoints.down('lg')]: {
      width: '100%'
    },
    [theme.breakpoints.up('lg')]: {
      width: '100%'
    }
  },
  headerRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    margin: '0px 20px 24px'
  },
  cardsRow: {
    display: 'flex',
    gap: theme.spacing(3),
    margin: 0,
    maxWidth: 860
  },
  transaction: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    width: 'calc((100% - 24px) / 2)',
    background: theme.palette.common.white,
    borderRadius: theme.spacing(),
    padding: theme.spacing(4)
  },
  transactionIcon: {
    width: theme.spacing(9),
    height: theme.spacing(9),
    background: 'rgba(40,167,69,0.1)',
    borderRadius: theme.spacing(),
    marginRight: theme.spacing(3),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  overdueIcon: {
    width: theme.spacing(9),
    height: theme.spacing(9),
    background: theme.palette.badge.warning.bg,
    color: theme.palette.badge.warning.text,
    borderRadius: theme.spacing(),
    marginRight: theme.spacing(3),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 24,
    fontWeight: 800
  },
  icon: {
    fill: theme.palette.primary.main
  },
  buttons: {
    height: 44,
    letterSpacing: 1.25,
    fontSize: 16,
    fontWeight: '400',
    minWidth: 'unset'
  },
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    gap: theme.spacing(2),
    margin: '10px 0px 20px 16px'
  },
  toolbarLeft: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: theme.spacing(2)
  },
  toolbarRight: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1)
  },
  toolbarContract: {
    width: 250,
    height: 42,
    background: theme.palette.common.white
  },
  statusFilters: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 4,
    height: 42,
    padding: 4,
    background: theme.palette.common.white,
    border: '1px solid #eeeeee',
    borderRadius: theme.spacing()
  },
  statusChip: {
    height: 32,
    border: 0,
    borderRadius: theme.spacing(),
    padding: '0 12px',
    fontSize: 12,
    fontWeight: 800,
    letterSpacing: '0.05em',
    textTransform: 'uppercase',
    color: '#606a75',
    '&.Mui-selected': {
      background: theme.palette.badge.info.bg,
      color: theme.palette.badge.info.text
    },
    '&.Mui-selected:hover': {
      background: theme.palette.badge.info.bg
    }
  },
  cutoffButton: {
    height: 40,
    minWidth: 202,
    justifyContent: 'space-between',
    gap: 14,
    textTransform: 'none',
    border: '1px solid #153750',
    background: theme.palette.common.white,
    padding: '0 20px'
  },
  cutoffButtonLabel: {
    color: '#68717c',
    fontSize: 12,
    fontWeight: 800,
    letterSpacing: '0.06em',
    textTransform: 'uppercase'
  },
  cutoffButtonValue: {
    fontSize: 14,
    fontWeight: 800,
    marginLeft: theme.spacing(1)
  },
  downloadButton: {
    height: 40,
    border: '1px solid #153750',
    color: '#153750',
    background: theme.palette.common.white,
    textTransform: 'uppercase',
    fontWeight: 500,
    fontSize: 14,
    padding: '0 20px'
  }
}));
